import { UpgradeSelectionPropTypes } from './UpgradeSelectionPropTypes';
import UpgradeSelectionView from './UpgradeSelectionView';

const UpgradeSelectionController = (props: UpgradeSelectionPropTypes) => (
  <UpgradeSelectionView {...props} />
);

export default UpgradeSelectionController;
